import { ActionEventAction, ElementEventAction, EventTriggerFixed } from 'services/Analytics/core';

import { trackClick, trackEventFixed } from './mainTrackers';

export const sendAnalyticDeeplinkLoadClick = () => {
    trackEventFixed({ event: EventTriggerFixed.deeplinkLoad });
};

export const sendAnalyticDownloadAppClick = (eventLabel: string) => {
    trackClick({
        elementEvent: ElementEventAction.button,
        actionEvent: ActionEventAction.downloadApp,
        eventLabel,
    });
};
